export default {
  nav:[
    {
      name: "首页",
      path: "/",
      children: []
    },
    {
      name: "公司介绍",
      path: "/company",
      meta:{index:0},
      children: [
        {
          name: "公司简介",
          path: "/company/info",
          meta:{index:0},
        },
        {
          name: "公司沿革",
          path: "/company/time",
          meta:{index:0},
        },
        {
          name: "工厂介绍",
          path: "/company/factory",
          meta:{index:0},
        }
      ]
    },
    {
      name: "公司动态",
      path: "/company/news",
      meta:{index:1},
      children: [
        {
          name: "公司新闻",
          path: "/company/news",
          meta:{index:1},
        },
        {
          name: "行业动态",
          path: "/dynamics",
          meta:{index:1},
        },
      ]
    },
    {
      name: "产品系列",
      path: "/product?id=mini&index1=0",
      meta:{index:2},
      children: [
        {
          name:'Mini LED',
          path: "/product?id=mini&index1=0",
          meta:{index:2},
        },
        {
          name:'Micro LED',
          path: "",
          meta:{index:2},
        },
        {
          name:'Force Touch',
          path: "/product?id=force&index1=0",
          meta:{index:2},
        },
      ]
    },
    {
      name: "加入我们",
      path: "/job",
      meta:{index:3},
      children: [
        {
          name: "社会招聘",
          type:"2",
          path: "https://www.zhaopin.com/companydetail/CZL1368651860.htm?refcode=4019&srccode=401901&preactionid=247fd5fc-e2cc-4226-88b9-cfefcaddf5ef",
          meta:{index:3},
        },
        {
          name: "校园招聘",
          path: "/job/campusrecruitment",
          meta:{index:3},
        }
      ]
    },
    {
      name: "联系我们",
      path: "/contactus",
      meta:{index:4},
      children: [
        {
          name: "联系方式",
          path: "/contactus",
          meta:{index:4},
        },
        {
          name: "技术咨询",
          path: "/ContactForm",
          meta:{index:4},
        },
        {
          name: "样品申请",
          path: "/ContactForm2",
          meta:{index:4},
        },
      ]
    },
  ],
  swiperList: [
    {
      img: require("@/assets/img/banner1.png"),
      path: "",
      title: '以持续领先的技术自主创新能力，成为全球Mini/Micro LED视显方案领先公司',
    },
    {
      img: require("@/assets/img/banner2.png"),
      path: "",
      title: '为客户提供最佳定制方案，打造极致体验',
    },
    {
      img: require("@/assets/img/banner3.png"),
      path: "",
      title: '2022年，通州工厂已开始投入量产',
    },
  ],
  factoryTitle:"工厂介绍",
  factoryDesc:"北京芯能电子科技有限公司坐落于北京通州区方和正圆工业区，2022年开始投产。通州工厂主要生产Mini LED直显PKG产品，其采用AM驱动方式和公司独创的LoS PKG结构，具有PKG尺寸小、透光度好、低功耗等特点。除了可以应用在普通的室内外大型显示屏，在透明显示等专业及细分领域的应用中其优势更加突显。",
  companyDesc:'公司介绍',
  companyTitle:'北京芯能电子科技有限公司',
  companyInfo:`北京芯能电子科技有限公司为探路者集团控股子公司，是一家Mini/Micro LED显示驱动IC及解决方案提供商，是目前国内少数具有主动式直显、背光驱动两条产品线的IC设计公司。主要产品包括Mini/Micro LED驱动IC、压力触控IC等。北京芯能的显示驱动芯片产品采用其独特的主动式（AM）驱动方式，在Mini LED直显和背光领域具有技术领先性。北京芯能的Mini LED 主动式驱动芯片已在国内及韩国的显示行业中得到认可，并且与行业内客户们建立了紧密的合作关系。北京芯能在Fabless经营模式上，适当向下游延伸，自建部分封装产线并不断扩大产能。
          北京芯能核心研发团队来自于韩国，在新型显示领域具有多年工作和量产经验，并已积累了多项自主核心技术和数十项发明专利，在核心技术应用方面确保了技术竞争优势。`,
  historyTitle:"公司沿革",
  historyList: [
    {
      id: "1",
      title: `
      <p>通州工厂建设及投产</p>
      <p>探路者成为北京芯能控股股东</p>`,
      year: "2022",
    },
    {
      id: "2",
      title: 
      `
      <p>北京芯能100%收购SiliconInside</p>
      <p>安徽芯能迁址至北京，并更名为北京芯能电子科技有限公司</p>
      <p>开发Mini LED背光驱动IC</p>
      `,
      year: "2021",
    },
    {
      id: "3",
      title: 
      `
      <p>开发Mini LED直显Pixel PKG</p>
      <p>开发Mini LED直显驱动IC</p>
      <p>开发Mini LED背光调光驱动IC</p>
      `,
      year: "2020",
    },
    {
      id: "4",
      title: 
      `
      <p>开发Force Sensor ROIC</p>
      <p>成立安徽芯能电子科技有限公司</p>
      <p>开发微显示用μLED 背板IC </p>
      `,
      year: "2019",
    },
    {
      id: "5",
      title: 
      `
      <p>开发电感应压力传感器读出IC</p>
      <p>开发智能车灯用μLED背板IC</p>
      `,
      year: "2018",
    },
    {
      id: "6",
      title: 
      `
      <p>开发μLED Array Driver IC</p>
      `,
      year: "2016",
    },
    {
      id: "10",
      title: 
      `
      <p>8-channel Touch Sensor 产品量产(Commax) </p>
      `,
      year: "2014",
    },
    {
      id: "7",
      title: 
      `
      <p>开发Automotive Navigation用LCD driver IC</p>
      `,
      year: "2013",
    },
    {
      id: "9",
      title: 
      `
      <p>被知识经济部选定为Star Fabless</p>
      `,
      year: "2012",
    },
    {
      id: "8",
      title: 
      `
      <p>成立(株) SiliconInside</p>
      `,
      year: "2009",
    },
  ],
  factoryImg:require("@/assets/img/factory.jpg"),
  hr:{
    title:"人事信息",
    one:"校园招聘策划中，如有学校想与BXET合作，请随时联系！",
    two:"张永杰 （人事总监）- 13668048025 - yongjie.zhang@bx-vision.cn",
    three:"张春姬（人事主管）- 19901469540 - chunji.zhang@bx-vision.cn",
  },
  mapInfo:[
    { point1:116.439133,point2:39.927164,mapName:"北京芯能",mapTitle:"银河SOHO B座21003",
      name:"北京总部",title:"电子科技有限公司",add:"北京市东城区南竹杆胡同2号银河SOHO B座21003",pc:'10010',tel:"010-59576010/6011",email:"bxet@bx-vision.cn"},
    { point1:116.7286,point2:39.861089,mapName:"芯能通州区M2工厂",mapTitle:"方和正圆2号厂房",
      name:"北京工厂",title:"通州区M2工厂",add:"北京市通州区张家湾镇光华路16号方和正圆2号厂房",pc:'102299',tel:"010-59576010/6011",email:"bxet@bx-vision.cn"},
    { point1:113.9586,point2:22.546662,mapName:"芯能深圳市办事处",mapTitle:"大冲商务中心B座3309",
      name:"深圳办事处",title:"深圳市办事处",add:"广东省深圳市南山区深南大道9676号大冲商务中心B座3309",pc:'518000',tel:"010-59576010/6011",email:"bxet@bx-vision.cn"},
    { point1:127.04138980210135,point2:37.48409036052456,mapName:"SILICONINSIDE",mapTitle:"Inhwan Building 2楼",
      name:"韩国R&D",title:"SILICONINSIDE",add:"韩国首尔市瑞草区论岘路163 Inhwan Building 2楼",pc:'06740',tel:"02-6447-1709",email:"sales@siliconinside.co.kr"},
  ],
  advice:{
    title:'技术咨询',
    name:"姓名（必填）",
    phone:"手机号（必填）",
    email:"邮箱（必填）",
    company:"公司（必填）",
    content:"内容（必填）",
    submit:"提交",
    name_pl:"请输入您的姓名",
    phone_pl:"请输入您的手机号",
    email_pl:"请输入您的邮箱",
    company_pl:"请输入您的公司",
    content_pl:"请输入您要咨询的内容",
  },
  application:{
    title:'样品申请',
    name:"姓名（必填）",
    phone:"手机号（必填）",
    email:"邮箱（必填）",
    company:"公司（必填）",
    content:"申请留言（必填）",
    submit:"提交",
    name_pl:"请输入您的姓名",
    phone_pl:"请输入您的手机号",
    email_pl:"请输入您的邮箱",
    company_pl:"请输入您的公司",
    content_pl:"请输入您要咨询的内容",
  },
  productTitle:"产品系列",
  productList:{
    mini: [
      {
        name: 'Mini LED 背光',
        img:require('@/assets/img/product_detail1.jpg'),
        type: [
          {
            name: 'Dimming Driver IC',
            tableId:1,
            list: [
              { a: 'AX3000', b: '2mm x 2mm DFN 8-Lead Cu/Ni/Au Bump',c: "4-CH", d: 'Typ.5.0V',e:"Typ. 5.0V",f:'21mA',g:'30V',h:'±3%',i:"±3%" },
              { a: 'AX3100', b: '2mm x 2mm DFN 10-Lead',c: "4-CH", d: 'Typ.5.0V',e:"3.3V/5.0V",f:'75mA',g:'40V',h:'±3%',i:"±3%" },
            ]
          },
          {
            name: 'Dimming Controller',
            tableId:2,
            list: [
              { a: 'AX9000', b: '14mm x 14mm LQFP 100-Lead',c: "SCAN 32-CH, DATA 32-CH", d: 'Typ. 5.0V',e:"3.3V",f:'SPI',g:'4,096 D/Z (64 x 64)',h:'7-bit'},
            ]
          }
        ]
      },
      {
        name: 'Mini LED 直显',
        img:require('@/assets/img/product_detail1.jpg'),
        type: [
          {
            name: 'Pixel Driver IC',
            tableId:3,
            list: [
              { a: 'AX2000', b: 'Bump (Cu/Ni/Au or Cu/SnAg)',c: "3-CH (R/G/B)", d: 'Typ. 5.0V',e:"Typ. 5.0V",f:"600/429/375 uA",g:'10-bit'},
              { a: 'AX2000A', b: 'Bump (Cu/Ni/Au or Cu/SnAg)',c: "3-CH (R/G/B)", d: 'Typ. 5.0V',e:"Typ. 5.0V",f:"9.61/6.89/6.03 mA",g:'10-bit'},
              { a: 'AX2200', b: 'Bump (Cu/Ni/Au or Cu/SnAg)',c: "3-CH (R/G/B)", d: '3.3V',e:"3.3V",f:"9.61/6.89/6.03 mA",g:'14-bit'},
            ]
          },
          {
            name: 'IC embedded pixel IC',
            tableId:4,
            list: [
              { a: 'AXP000', b: '0.8mm x 0.8mm (4-Pin)',c: "Typ. 5.0V", d: 'Typ. 5.0V',e:"6/14/2 mcd (T.B.D)",f:'R:G:B = 3:7:1',g:'10-bit'},
              { a: 'AXP000A', b: '0.8mm x 0.8mm (4-Pin)',c: "Typ. 5.0V", d: 'Typ. 5.0V',e:"192/224/64 mcd (T.B.D)",f:'R:G:B = 3:7:1',g:'10-bit'},
              { a: 'AXP020', b: '0.9mm x 1.15mm (5-Pin)',c: "Typ. 5.0V", d: 'Typ. 3.3V',e:"192/224/64 mcd (T.B.D)",f:'R:G:B = 3:7:1',g:'14-bit'},
            ]
          },
          {
            name: 'SCAN/DATA Driver IC',
            tableId:5,
            list: [
              { a: 'AX8000', b: '8mm x 8mm QFN 64-Lead',c: "32-CH", d: 'Typ. 5.0V',e:"Typ. 3.3V",f:'Cascaded SPI',g:'6-bit'},
            ]
          }
        ]
      },
    ],
    force: [
      {
        name: 'Force Touch',
        img:require('@/assets/img/product_detail2.jpg'),
        type: [
          {
            name: 'Force Touch',
            tableId:6,
            list: [
              { a: 'AX1002', b: '4mm x 4mm QFN 32-Lead 2.65mm x 1.63mm WLCSP 24-Lead',c: "Typ. 3.3V", d: '1.65 ~ 3.6V',e:"8-CH (QFN) 4-CH (WLCSP)",f:'I2C',g:'14-bit',h:'Spiral Coil Pattern on PCB'},
            ]
          },
        ]
      },
    ]
  },
  studentTitle:'校园招聘',
  contactTitle:'联系我们',
}



// WEBPACK FOOTER //
// ./src/lang/zh.js